import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import {
  FaShoppingCart,
  FaFacebookSquare,
  FaInstagramSquare,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import { FiDownloadCloud } from "react-icons/fi";

import sendMessage from "../scripts/sendWaMessage";

function Home({ baseURL }) {
  const [view, setView] = useState(0);
  const [viewProgram, setViewProgram] = useState(false);
  const [program, setProgram] = useState({});
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [webContent, setWebContent] = useState([]);

  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const sendUrlParam = (name, value) => {
    query.set(name, value); // Cambia o agrega ?id=nuevoValor
    navigate(`?${query.toString()}`);
  };

  const programId = query.get("view");
  useEffect(() =>
    programId !== null ? setView(parseInt(programId)) : setView(0)
  , [search]);

  // Cargar contenido dinámico de la web
  useEffect(() => {
    fetch(baseURL + "/sections")
      .then((res) => res.json())
      .then((data) => {
        setWebContent(data);
      })
      .catch(console.error);
    fetch(baseURL + "/licenses")
      .then((res) => res.json())
      .then((data) => {
        setLicenses(data);
      })
      .catch(console.error);
  }, []);

  //Contenido de cada sección
  const content0 = webContent.find((el) => el.name === "Inicio");
  const content2 = webContent.find((el) => el.name === "Acerca de");
  const content3 = webContent.find((el) => el.name === "Contactenos");
  const content4 = webContent.find((el) => el.name === "Ayuda");
  const content5 = webContent.find((el) => el.name === "Tutoriales");
  const content6 = webContent.find((el) => el.name === "Mas");

  // Cargar items según colección activa
  useEffect(() => {
    fetch(baseURL + "/posts")
      .then((res) => res.json())
      .then((data) => {
        setItems(data);
      })
      .catch(console.error);

    fetch(baseURL + "/categories")
      .then((res) => res.json())
      .then((data1) => {
        setCategories(data1);
      })
      .catch(console.error);
  }, []);

  if (webContent.length > 0) {
    return (
      <>
        <header id="hero">
          {content0.header.image && (
            <div className="hero0">
              <img
                src={
                  content0.header.image ||
                  "https://placehold.co/500x350/3473ad/fff?text=Logo"
                }
                alt="heroImg"
                draggable={false}
              />
            </div>
          )}

          <div className="hero1">
            <h1>{content0.header.title}</h1>
            <p>{content0.header.text}</p>
            <a href="#main-nav">
              <button>Comenzar</button>
            </a>
          </div>
        </header>

        <nav className="main-nav" id="main-nav">
          <p onClick={() => setView(0)}>Inicio</p>
          <p onClick={() => setView(1)}>Programas</p>
          <p onClick={() => setView(2)}>Acerca de</p>
          <p onClick={() => setView(3)}>Contáctenos</p>
          <p onClick={() => setView(4)}>Ayuda</p>
          <p onClick={() => setView(5)}>Tutoriales</p>
          <p onClick={() => setView(6)}>Màs</p>
        </nav>

        <div style={{ display: view === 0 ? "" : "none" }}>
          <section className="g-section">
            <h2>{content0.a.welcMessage}</h2>
          </section>
          {licenses.length > 0 && (
            <section className="g-section" id="section-licenses">
              <div className="licenses-grid">
                {licenses.map((license, index) => (
                  <article>
                    <h2>{license.name}</h2>
                    <p>{license.description} </p>
                    <ul>
                      {license.features.map((feature, index) => (
                        <>
                          <li>{feature}</li>
                        </>
                      ))}
                    </ul>
                    <button onClick={() => window.open(license.link)}>
                      <FaShoppingCart />
                    </button>
                  </article>
                ))}
              </div>
            </section>
          )}

          {categories.map((category, index) => (
            <section className="g-section" key={index} id="start-programs">
              <details className="collapse-programs">
                <summary>{category.name}</summary>
                <div className="grid-programs">
                  {items
                    .filter((item) => item.category === category.name)
                    .map((item, index) => (
                      <article
                        key={index}
                        onClick={() => {
                          setProgram({
                            name: item.name || "App " + index,
                            image: item.image,
                            description:
                              item.description ||
                              `descripcion del programa ${index}`,
                            category:
                              item.category || "category programa" + index,
                            links: item.links || "",
                            videoUrl: item.videoUrl || "",
                          });
                          window.scrollTo({ top: 100 });
                          navigate(`/program?${item.name}&id=${item._id}`);
                        }}
                      >
                        <img
                          src={
                            item.image ||
                            `https://placehold.co/150x150/222/fff?text=App+${index}`
                          }
                          alt={`Programa ${index}`}
                          draggable={false}
                        />
                        <div>
                          <h4>{item.name || "App " + index}</h4>
                          <p className="desc">
                            {item.description ||
                              `descripcion del programa ${index}`}
                          </p>
                          <p className="category">
                            {item.category || "category programa" + index}
                          </p>
                        </div>
                      </article>
                    ))}
                </div>
              </details>
            </section>
          ))}
        </div>

        {view === 1 && (
          <div>
            <section className="g-section" id="section-programs">
              <h2>Encuentra todas nuestras publicaciones</h2>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  alert("Buscando...");
                }}
              >
                <input
                  type="text"
                  placeholder="Buscar programas..."
                  className="search-input"
                />
                <button type="submit" className="search-button">
                  Buscar
                </button>
              </form>
              <div className="grid-programs">
                {items.map((item, index) => (
                  <article
                    key={index}
                    onClick={() => {
                      setProgram({
                        name: item.name || "App " + index,
                        image: item.image,
                        description:
                          item.description ||
                          `descripcion del programa ${index}`,
                        category: item.category || "category programa" + index,
                        links: item.links || "",
                        videoUrl: item.videoUrl || "",
                      });
                      window.scrollTo({ top: 100 });
                      navigate(`/program?${item.name}&id=${item._id}`);
                    }}
                  >
                    <img
                      src={
                        item.image ||
                        `https://placehold.co/150x150/222/fff?text=App+${index}`
                      }
                      alt={`Programa ${index}`}
                      draggable={false}
                    />
                    <div>
                      <h4>{item.name || "App " + index}</h4>
                      <p className="desc">
                        {item.description ||
                          `descripcion del programa ${index}`}
                      </p>
                      <p className="category">
                        {item.category || "category programa" + index}
                      </p>
                      {/*<button onClick={() => window.open(item.links)}>
                      <FiDownloadCloud />
                      Descargar
                    </button>*/}
                    </div>
                  </article>
                ))}
              </div>
            </section>
          </div>
        )}

        {view === 2 && (
          <div>
            <section className="g-section" id="section-about">
              <h2>{content2.c.title}</h2>
              {content2.c.img1 ? (
                <img src={content2.c.img1} alt="Equipo de trabajo" />
              ) : null}

              <div
                className="rendered-content"
                dangerouslySetInnerHTML={{ __html: content2.c.desc1 }}
              ></div>
              {content2.c.img2 ? (
                <img src={content2.c.img2} alt="Equipo de trabajo" />
              ) : null}

              <div
                className="rendered-content"
                dangerouslySetInnerHTML={{ __html: content2.c.desc2 }}
              ></div>
              {content2.c.img3 ? (
                <img src={content2.c.img3} alt="Equipo de trabajo" />
              ) : null}

              <div
                className="rendered-content"
                dangerouslySetInnerHTML={{ __html: content2.c.desc3 }}
              ></div>
              <button onClick={() => setView(4)}>AYUDA</button>
            </section>
          </div>
        )}

        {view === 3 && (
          <div>
            <section className="g-section" id="section-contact">
              <h2>{content3.d.title}</h2>
              <div
                className="rendered-content"
                dangerouslySetInnerHTML={{ __html: content3.d.desc1 }}
              ></div>
              {content3.d.number ? (
                <form onSubmit={sendMessage}>
                  <input
                    type="text"
                    placeholder="Tu nombre"
                    name="name"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Tu correo electrónico"
                    required
                  />
                  <textarea
                    placeholder="Tu mensaje"
                    name="message"
                    rows="4"
                    required
                  ></textarea>
                  <input
                    type="text"
                    name="phone"
                    value={content3.d.number}
                    style={{ display: "none" }}
                  />
                  <button type="submit">Enviar</button>
                </form>
              ) : null}
              {content3.d.email ? (
                <a href="mailto:">email@example.com</a>
              ) : null}
              <div className="social-icons">
                {content3.d.fb ? (
                  <a
                    href={content3.d.fb}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookSquare />
                  </a>
                ) : null}
                {content3.d.inst ? (
                  <a
                    href={content3.d.inst}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagramSquare />
                  </a>
                ) : null}
                {content3.d.Tkt ? (
                  <a
                    href={content3.d.Tkt}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTiktok />
                  </a>
                ) : null}
              </div>
            </section>
          </div>
        )}

        {view === 4 && (
          <div>
            <section className="g-section" id="section-help">
              <h2>{content4.e.title}</h2>
              {content4.e.questions.map((q, index) => (
                <details>
                  <summary>{q.q}</summary>
                  <p>{q.a}</p>
                </details>
              ))}
            </section>
          </div>
        )}

        {view === 5 && (
          <div>
            <section className="g-section" id="section-tutorials">
              <h2>{content5.f.title}</h2>
              <div
                className="rendered-content"
                dangerouslySetInnerHTML={{ __html: content5.f.desc1 }}
              ></div>

              <div class="videos-grid">
                <iframe
                  width="800"
                  height="400"
                  src={content5.f.video1}
                  title="Tutorial 1"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
                {content5.f.video2 ? (
                  <iframe
                    width="800"
                    height="400"
                    src={content5.f.video2}
                    title="Tutorial 3"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                ) : null}
              </div>
              {content5.f.UrlYoutube ? (
                <button
                  class="canal-btn"
                  onClick={() => window.open(content5.f.UrlYoutube)}
                >
                  <FaYoutube /> YouTube
                </button>
              ) : null}
            </section>
          </div>
        )}

        {view === 6 && (
          <div>
            <section className="g-section">
              <div
                className="rendered-content"
                dangerouslySetInnerHTML={{ __html: content6.g.desc1 }}
              ></div>
            </section>
          </div>
        )}

        {view === 10 && (
          <div>
            <section className="g-section" id="program-details">
              <div className="program-detail">
                <h2>{program.name}</h2>
                <img src={program.image} alt="programImg" draggable={false} />
                <p>{program.description}</p>
                {program.videoUrl && (
                  <>
                    <h3>Video Tutorial</h3>
                    <iframe src={program.videoUrl} frameborder="0"></iframe>
                  </>
                )}
                <button onClick={() => window.open(program.links)}>
                  <FiDownloadCloud />
                  Descargar
                </button>
              </div>
              <div className="program-detail-licenses">
                <div className="licenses-grid">
                  <article>
                    <h2>Licencia Windows 10</h2>
                    <p>
                      Lorem ipsum dolor sit, amet consectetur adipisicing elit.{" "}
                    </p>
                    <ul>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                    </ul>
                    <button>
                      <FaShoppingCart />
                    </button>
                  </article>
                  <article>
                    <h2>Licencia Windows 10</h2>
                    <p>
                      Lorem ipsum dolor sit, amet consectetur adipisicing elit.{" "}
                    </p>
                    <ul>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                    </ul>
                    <button>
                      <FaShoppingCart />
                    </button>
                  </article>
                  <article>
                    <h2>Licencia Windows 10</h2>
                    <p>
                      Lorem ipsum dolor sit, amet consectetur adipisicing elit.{" "}
                    </p>
                    <ul>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                      <li>corrupti ipsa eligendi quia eius in.</li>
                    </ul>
                    <button>
                      <FaShoppingCart />
                    </button>
                  </article>
                </div>
              </div>
            </section>
          </div>
        )}

        <footer>
          <div className="container">
            <section className="sect-0">
              <h3>Información</h3>
              <a
                href="#hero"
                onClick={(e) => {
                  setView(0);
                }}
              >
                Inicio
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  setView(1);
                }}
              >
                Programas
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  setView(3);
                }}
              >
                Contacto
              </a>
            </section>

            <hr />
            <br />

            <a
              href="https://bsitescomp.com"
              target="_blank"
              rel="noreferrer noopener"
              className="copyright"
            >
              &copy; 2025 Web Develop by <strong>B‑Sites</strong>
            </a>
          </div>
        </footer>
      </>
    );
  }
}

export default Home;
